<template>
  <div class="flex justify-center items-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-lg">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <h5 class="pt-2 text-xl font-bold text-center text-white">
        Sistem Aplikasi Penyaluran Beasiswa Kabupaten Puncak Papua
      </h5>

      <form
        class="overflow-hidden mt-4 bg-white rounded-lg shadow-xl"
        @submit.prevent="login">
        <div class="py-12 px-10">
          <div v-if="activeAnnouncement">
            <h1 class="text-3xl font-bold text-center">
              {{ activeAnnouncement.title }}
            </h1>
            <div class="mx-auto mt-4 w-24 border-b-2" />
            <div
              class="mt-4 -mb-6 text-sm text-justify announcement-content"
              v-html="activeAnnouncement.content" />
          </div>

          <text-input
            v-model="form.userid"
            autocomplete="username"
            :error="form.errors.userid"
            class="mt-10"
            label="Email / No.Rekening"
            type="text"
            autofocus
            autocapitalize="off" />
          <text-input
            v-model="form.password"
            autocomplete="current-password"
            :error="form.errors.password"
            class="mt-6"
            label="Password"
            type="password" />
        </div>
        <div class="flex py-4 px-10 bg-gray-100 border-t border-gray-100">
          <inertia-link
            v-if="$page.props.register_enabled"
            class="px-2 text-indigo-400 hover:text-indigo-600"
            :href="route('register.index')">
            Register
          </inertia-link>
          <loading-button
            :loading="form.processing"
            class="ml-auto btn-indigo"
            type="submit">
            Login
          </loading-button>
        </div>
        <div
          class="flex justify-center items-center py-4 px-10 bg-gray-100 border-t border-gray-100">
          Lupa password anda? silahkan klik
          <inertia-link
            class="pr-2 pl-1 text-indigo-400 hover:text-indigo-600"
            :href="route('password.request')">
            disini
          </inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Login' },
  props: {
    activeAnnouncement: {
      type: Object,
      default: null,
    },
  },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    'inertia-link': Link,
  },
  data () {
    return {
      form: this.$inertia.form({
        userid: null,
        password: null,
        remember: false,
      }),
    }
  },
  methods: {
    login () {
      this.form.post(this.route('login.store'))
    },
  },
}
</script>

<style scoped>
.announcement-content >>> h1 {
  @apply text-xl font-bold mb-2;
}

.announcement-content >>> h2 {
  @apply text-lg font-bold mb-2;
}

.announcement-content >>> h3 {
  @apply text-base font-bold mb-2;
}

.announcement-content >>> p {
  @apply mb-2;
}

.announcement-content >>> ul {
  @apply list-disc pl-5 mb-2;
  padding-left: 1.25rem;
  margin-left: 0.5rem;
}

.announcement-content >>> ol {
  @apply list-decimal pl-5 mb-2;
  padding-left: 1.25rem;
  margin-left: 0.5rem;
}

.announcement-content >>> ul li {
  @apply mb-1;
}

.announcement-content >>> ol li {
  @apply mb-1;
}

.announcement-content >>> ul li::marker {
  color: #6b7280;
}

.announcement-content >>> ol li::marker {
  color: #6b7280;
}

.announcement-content >>> a {
  @apply text-indigo-600 underline;
}

.announcement-content >>> strong {
  @apply font-bold;
}
</style>
